import styled from "styled-components";

export const StyledDialogWrapper= styled.div`
  padding: 20px;
  display: grid;
  grid-template-columns: 100%;
  position: relative;
`;

export const StyledDialogHead= styled.div`
  margin: 10px 0 25px;
  color: ${({theme}) => theme.dialog.headColor};
  font-size: 18px;
  font-weight: 600;
  text-align: center;
`;

export const StyledDialogContent = styled.div`
  //max-width: 450px;
  width: 100%;
  background-color: ${({theme}) => theme.dialog.background};
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 25px;
  
  p {
    font-size: 14px;
    text-align: left;
  }
`;

export const StyledDialogAction = styled.div`
  height: 45px;
  margin: 25px 0 0;
  display: grid;
  grid-template-columns: repeat(${({ col }) => col}, 1fr);
  grid-gap: 20px;

  button {
    height: 100%;
  }

  @media screen and (max-width: 480px) {
    height: auto;
    display: flex;
    flex-direction: column-reverse;

    button {
      height: 50px;
    }
  }
`;

export const StyledDialogClose = styled.div`
  width: 25px;
  height: 25px;
  padding: 5px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: absolute;
  top: 5px;
  right: 5px;
  transition: all .3s ease;
  cursor: pointer;

  &:hover {
    background-color: ${({theme}) => theme.dialog.closeHoverBackground};
  }
`;